import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import rest from "./rest.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    rest,
    htmlClass,
    config,
    breadcrumbs,
    profile
  },
  plugins: []
});
